module.exports = __webpack_public_path__ + "assets/images/6f5d7b345d967d8ab3a3594fd9b9f3d1.png";